import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("soeasy_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // apenas limpar; deixar componente redirecionar
    }
    return Promise.reject(err);
  }
);

export const auth = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  me: () => api.get("/auth/me"),
  logout: () => { localStorage.removeItem("soeasy_token"); localStorage.removeItem("soeasy_user"); },
};

export const compliance = {
  dashboard: () => api.get("/compliance/dashboard"),
  processos: (status) => api.get("/compliance/processos", { params: status ? { status_filter: status } : {} }),
  processo: (id) => api.get(`/compliance/processos/${id}`),
  criarOcorrencia: (data) => api.post("/compliance/ocorrencias", data),
  atualizarProcesso: (id, data) => api.patch(`/compliance/processos/${id}`, data),
  criarEvidencia: (data) => api.post("/compliance/evidencias", data),
  criarEntrevista: (data) => api.post("/compliance/entrevistas", data),
  criarParecer: (data) => api.post("/compliance/pareceres", data),
  criarDecisao: (data) => api.post("/compliance/decisoes", data),
  denuncias: () => api.get("/compliance/denuncias"),
};

export const ia = {
  classificar: (descricao) => api.post("/ia/classificar", { descricao }),
  parecer: (processo_id) => api.post("/ia/parecer", { processo_id }),
  risco: (descricao) => api.post("/ia/risco", { descricao }),
};

export const docs = {
  list: () => api.get("/documentos"),
  categorias: () => api.get("/documentos/categorias"),
  criar: (data) => api.post("/documentos", data),
  ler: (id) => api.post(`/documentos/${id}/ler`),
  assinar: (id) => api.post(`/documentos/${id}/assinar`),
  dashboard: () => api.get("/documentos/dashboard"),
};

export const orc = {
  list: () => api.get("/orcamentos"),
  get: (id) => api.get(`/orcamentos/${id}`),
  criar: (data) => api.post("/orcamentos", data),
  addItem: (data) => api.post("/orcamentos/itens", data),
  delItem: (id) => api.delete(`/orcamentos/itens/${id}`),
  cbos: () => api.get("/orcamentos/cbos"),
  ccts: (uf) => api.get("/orcamentos/ccts", { params: uf ? { uf } : {} }),
};

export const publico = {
  denuncia: (data) => api.post("/publico/denuncia", data),
  status: (proto) => api.get(`/publico/denuncia/status/${proto}`),
};

export const sgo = {
  clientes: (q) => api.get("/sgo/clientes", { params: q ? { q } : {} }),
  cliente: (id) => api.get(`/sgo/clientes/${id}`),
  criarCliente: (data) => api.post("/sgo/clientes", data),
  editarCliente: (id, data) => api.patch(`/sgo/clientes/${id}`, data),
  deletarCliente: (id) => api.delete(`/sgo/clientes/${id}`),
  dashboard: () => api.get("/sgo/dashboard"),
};

export const cct = {
  list: (params) => api.get("/orcamentos/ccts", { params }),
  criar: (data) => api.post("/orcamentos/ccts", data),
  editar: (id, data) => api.patch(`/orcamentos/ccts/${id}`, data),
  deletar: (id) => api.delete(`/orcamentos/ccts/${id}`),
  parsePdf: (texto) => api.post("/orcamentos/ccts/parse-pdf", { texto }),
};

export const atd = {
  dashboard: () => api.get("/atendimento/dashboard"),
  tickets: (params) => api.get("/atendimento/tickets", { params }),
  ticket: (id) => api.get(`/atendimento/tickets/${id}`),
  criarTicket: (data) => api.post("/atendimento/tickets", data),
  atualizarTicket: (id, data) => api.patch(`/atendimento/tickets/${id}`, data),
  addInteracao: (id, data) => api.post(`/atendimento/tickets/${id}/interacoes`, data),
  nps: () => api.get("/atendimento/nps"),
  criarNps: (data) => api.post("/atendimento/nps", data),
  clientes360: () => api.get("/atendimento/clientes-360"),
  cliente360: (id) => api.get(`/atendimento/clientes-360/${id}`),
  kb: (params) => api.get("/atendimento/kb", { params }),
  criarKb: (data) => api.post("/atendimento/kb", data),
  kbGet: (id) => api.get(`/atendimento/kb/${id}`),
  iaClassificar: (assunto, descricao) => api.post("/atendimento/ia/classificar", { assunto, descricao }),
  iaSugerir: (ticket_id) => api.post("/atendimento/ia/sugerir-resposta", { ticket_id }),
  iaSentimento: (texto) => api.post("/atendimento/ia/sentimento", { texto }),
};

export const npsPublico = {
  get: (token) => api.get(`/publico/nps/${token}`),
  responder: (token, data) => api.post(`/publico/nps/${token}/responder`, data),
};

export const rh = {
  empresas: () => api.get("/rh/empresas"),
  criarEmpresa: (data) => api.post("/rh/empresas", data),
  colaboradores: (params) => api.get("/rh/colaboradores", { params }),
  colaborador: (id) => api.get(`/rh/colaboradores/${id}`),
  criarColaborador: (data) => api.post("/rh/colaboradores", data),
  editarColaborador: (id, data) => api.patch(`/rh/colaboradores/${id}`, data),
  desligar: (id, data) => api.post(`/rh/colaboradores/${id}/desligar`, data),
  dashboard: () => api.get("/rh/dashboard"),
  tiNotificacoes: () => api.get("/rh/ti/notificacoes"),
};

export const fin = {
  dashboard: () => api.get("/financeiro/dashboard"),
  contas: (params) => api.get("/financeiro/contas", { params }),
  criarConta: (data) => api.post("/financeiro/contas", data),
  editarConta: (id, data) => api.patch(`/financeiro/contas/${id}`, data),
  deletarConta: (id) => api.delete(`/financeiro/contas/${id}`),
  tributos: () => api.get("/financeiro/tributos"),
  criarTributo: (data) => api.post("/financeiro/tributos", data),
  notas: (tipo) => api.get("/financeiro/notas", { params: tipo ? { tipo } : {} }),
  criarNota: (data) => api.post("/financeiro/notas", data),
  fluxoCaixa: () => api.get("/financeiro/fluxo-caixa"),
};

export const jur = {
  dashboard: () => api.get("/juridico/dashboard"),
  contratos: (params) => api.get("/juridico/contratos", { params }),
  contrato: (id) => api.get(`/juridico/contratos/${id}`),
  criarContrato: (data) => api.post("/juridico/contratos", data),
  editarContrato: (id, data) => api.patch(`/juridico/contratos/${id}`, data),
  processos: (params) => api.get("/juridico/processos", { params }),
  criarProcesso: (data) => api.post("/juridico/processos", data),
  pareceres: () => api.get("/juridico/pareceres"),
  criarParecer: (data) => api.post("/juridico/pareceres", data),
  adequacao: () => api.get("/juridico/adequacao"),
  criarAdequacao: (data) => api.post("/juridico/adequacao", data),
};

export const ti = {
  dashboard: () => api.get("/ti/dashboard"),
  fila: () => api.get("/ti/fila"),
  provisionados: () => api.get("/ti/provisionados"),
  buscarColaborador: (cpf) => api.post("/ti/buscar-colaborador", { cpf }),
  criarIdentidade: (data) => api.post("/ti/identidade", data),
  ativos: () => api.get("/ti/ativos"),
  criarAtivo: (data) => api.post("/ti/ativos", data),
  comodatos: () => api.get("/ti/comodatos"),
  criarComodato: (data) => api.post("/ti/comodatos", data),
  notificacoesRh: () => api.get("/ti/notificacoes-rh"),
  executarRevogacao: (id) => api.post(`/ti/notificacoes-rh/${id}/executar`),
};

export const mkt = {
  dashboard: () => api.get("/marketing/dashboard"),
  campanhas: (params) => api.get("/marketing/campanhas", { params }),
  criarCampanha: (data) => api.post("/marketing/campanhas", data),
  leads: (params) => api.get("/marketing/leads", { params }),
  criarLead: (data) => api.post("/marketing/leads", data),
  conteudos: () => api.get("/marketing/conteudos"),
  criarConteudo: (data) => api.post("/marketing/conteudos", data),
  iaCopy: (tema, canal, tom) => api.post("/marketing/ia/copy", { tema, canal, tom }),
  iaPlano: (contexto) => api.post("/marketing/ia/plano", { contexto }),
};

export const admin = {
  users: () => api.get("/users"),
  suspender: (id) => api.post(`/users/${id}/suspender`),
  solicitacoes: () => api.get("/admin/solicitacoes"),
  criarUsuario: (data) => api.post("/auth/register", data),
};
